.chatMessage {
    width: 100%;
    padding: 20px;
    min-height: 150px;
}

.chatmessage {
    background-color: transparent;
    border-radius: 5px;
    padding: 12px 16px;
    margin: 0;
    width: 100%;
    opacity: 0;
    animation: fadeIn 0.5s ease-in-out forwards;
}

.chatmessageUser {
    .chatmessage();
}

.chatmessageAI {
    .chatmessage();
}

.userBubble {
    background-color: #f1f7fe;
    border-radius: 8px;
    padding: 8px 16px;
    width: fit-content;
    max-width: 70%;
    align-self: flex-end;
    word-wrap: break-word;
}

.agentMessage {
    background-color: #e8f0fe !important;
    padding: 20px !important;
    border-radius: 10px !important;
    filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.2));
}
.aiContent {
    max-width: 75%;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #323b48;
    line-height: 1.5;
    letter-spacing: -0.15px;

    // Compact markdown typography
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Hanken Grotesk', sans-serif;
        font-weight: 700;
        margin-top: 12px;
        margin-bottom: 4px;
        line-height: 1.2;
    }
    h1 {
        font-size: 18px;
    }
    h2 {
        font-size: 16px;
    }
    h3 {
        font-size: 15px;
    }
    h4,
    h5,
    h6 {
        font-size: 14px;
    }

    p {
        margin-top: 0;
        margin-bottom: 8px;
        font-size: 14px;
        line-height: 2.2;
    }

    ul,
    ol {
        padding-left: 20px;
        margin-bottom: 8px;
    }

    li {
        font-size: 14px;
        margin-bottom: 2px;
    }

    table {
        font-size: 13px;
        border-collapse: collapse;
        margin-bottom: 8px;
        width: 100%;
        table-layout: auto;
        display: block;
        overflow-x: auto;
    }

    th,
    td {
        padding: 4px 8px;
        border: 1px solid #eceef2;
        text-align: left;
        vertical-align: top;
        white-space: nowrap;
    }

    th {
        font-weight: 600;
        background-color: #f9fafb;
    }

    strong,
    b {
        font-weight: 700;
    }

    code {
        font-size: 12px;
        background-color: #f3f4f6;
        padding: 1px 4px;
        border-radius: 3px;
    }

    blockquote {
        border-left: 3px solid #eceef2;
        margin: 0 0 8px 0;
        padding-left: 12px;
        color: #6b7280;
        font-size: 13px;
    }
}

.citation_class {
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    margin: 3px 4px 3px 0;
    font-size: 12px;
    font-weight: 500;
    color: #4a90e2;
    background-color: #f0f7ff;
    border: 1px solid #d0e7ff;
    border-radius: 4px;
    text-decoration: none;
    white-space: nowrap;
    vertical-align: middle;
    line-height: 1.4;
    transition: all 0.2s ease;

    &:hover {
        background-color: #e0f0ff;
        border-color: #4a90e2;
        color: #2a70c2;
        text-decoration: none;
    }

    &:active {
        background-color: #d0e7ff;
    }
}
